<template>
	<view class="password-modal" v-if="showSecPasswordModal">
		<view class="modal-mask"></view>
		<view class="modal-container">
			<view class="modal-title">请输入二级密码</view>
			<view class="modal-content">
				<view class="password-input-container">
					<input type="password" class="password-input" placeholder="请输入二级密码" maxlength="6" password
						@input="onPasswordInput" :focus="props.secondData.secPasswordInputFocus" />
				</view>
				<view class="error-tip" v-if="props.secondData.passwordError">{{props.secondData.passwordErrorMsg}}</view>
			</view>
			<view class="modal-footers">
				<up-button
				class="circle_btn"
				shape="circle" 
				:color="vuex_skinColor" 
				:style="{'background-color':'#fff' + '!important','height': '56rpx','margin-left':'30rpx','color':vuex_skinColor}"
				@click="onCancel">取消
				</up-button>
				<up-button
				shape="circle" 
				:color="vuex_skinColor" 
				:style="{'background-color':vuex_skinColor + '!important','height': '56rpx','margin-right':'30rpx','margin-left':'30rpx'}"
				@click="onConfirm">确认
				</up-button>
			</view>
		</view>
	</view>
</template>

<script setup>
	import { onLoad, onShow } from '@dcloudio/uni-app';
	import { getCurrentInstance, reactive, ref} from 'vue';
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	
	//defineProps接收父组件传输的数据
	const props = defineProps({
		// 控制二级密码弹窗是否显示
		showSecPasswordModal: {
			type: Boolean,
		},
		// 二级密码相关数据对象
		secondData: {
			type: Object,
		}
	})

	// 定义可以触发的事件
	const emit = defineEmits(['account-close','account-confirm','on-password-input', 'on-input-foucs'])
	
	// 点击取消按钮处理事件
	const onCancel = () => {
		emit('account-close')
	}
	
	// 点击确认按钮处理事件
	const onConfirm = () => {
		emit('account-confirm')
	}
	
	// 页面加载时执行
	onLoad(() => {
		
	})
	
	// 页面显示时执行
	onShow(() => {
		
	})
	
	// 二级密码输入事件处理
	function onPasswordInput(e) {
		emit('on-password-input', {
			inputSecondPassword: e.detail.value
		})
	}
	
</script>

<style>
	
	/* 二级密码弹窗样式 */
	.password-modal {
	  position: fixed;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  z-index: 999;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	}
	
	.modal-mask {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  background-color: rgba(0, 0, 0, 0.6);
	}
	
	.modal-container {
	  position: relative;
	  width: 80%;
	  max-width: 300px;
	  background-color: #fff;
	  border-radius: 8px;
	  overflow: hidden;
	  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}
	
	.modal-title {
	  padding: 20px 10px;
	  text-align: center;
	  font-size: 15px;
	  font-weight: bold;
	  color: #333;

	}
	
	.modal-content {
	  width:80%;
	  /* padding: 20px 16px; */
	  padding-left: 32rpx;
	  padding-right: 32rpx;
	  padding-bottom: 40rpx;
	  margin:0 auto;
	  /* margin-bottom: 16px; */
	}
	
	.password-input-container {
	  position: relative;
	  height: 40px;
	  border: 1px solid #ddd;
	  border-radius: 4px;
	  overflow: hidden;
	}
	
	.password-input {
	  width: 100%;
	  height: 100%;
	  padding: 0 10px;
	  font-size: 14px;
	  color: #333;
	}
	
	.error-tip {
	  margin-top: 8px;
	  color: #f56c6c;
	  font-size: 12px;
	  text-align: center;
	  min-height: 16px;
	}
	
	.modal-footers {
	  display: flex;
	  width:80%;
	  margin:0 auto;
	  margin-bottom: 40rpx;
	}
	
	.modal-footer {
	  display: flex;
	  width:80%;
	  margin:0 auto;
	  margin-bottom: 16px;
	}
	
	.modal-footer button {
	  flex: 1;
	  height: 30px;
	  line-height: 30px;
	  text-align: center;
	  font-size: 14px;
	  background-color: #fff;
	  margin-bottom: 14px;
	  color: #333;
	  border: none;
	  width: 40px;
	  outline: none;
	}
	
	.modal-footer button:first-child {
	  background: #fff;
	  line-height: 30px;
	  border-radius: 20px;
	  border:1rpx solid #3a8a79;
	}
	
	.modal-footer button.confirm-btn {
	  color: #fff;
	  font-weight: 500;
	  background-color:#3a8a79 ;
	  line-height: 30px;
	  border-radius: 20px;
	  margin-left: 16px;
	}
</style>